// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateOrder_wrapper__HaIhj","formContainer":"CreateOrder_formContainer__R8qOY","limits":"CreateOrder_limits__hJfdq"};